export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://business-training.by/razvitie-personala/otsenka-i-razvitie-sotrudnikov#service",
        "name": "Оценка и развитие сотрудников",
        "description": "Оценка сотрудников и управленческих компетенций: выявление сильных сторон и зон развития, кадровый резерв, индивидуальные планы развития и корпоративное обучение.",
        "provider": { "@id": "https://business-training.by/o-trenere#person" },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "оценка сотрудников, оценка компетенций, оценка персонала, развитие сотрудников, кадровый резерв",
        "url": "https://business-training.by/razvitie-personala/otsenka-i-razvitie-sotrudnikov"
      },
      {
        "@type": "WebPage",
        "name": "Оценка и развитие сотрудников: как определить потенциал и точки роста команды",
        "description": "Оценка сотрудников и управленческих компетенций: выявление сильных сторон и зон развития, кадровый резерв, индивидуальные планы развития и корпоративное обучение.",
        "url": "https://business-training.by/razvitie-personala/otsenka-i-razvitie-sotrudnikov",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Person",
        "@id": "https://business-training.by/o-trenere#person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Зачем компании оценивать сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оценка сотрудников нужна не ради рейтинга, а для принятия управленческих решений: понять, какие компетенции уже развиты, каких не хватает, кто готов к более сложной роли, кому требуется обучение, кого можно включить в кадровый резерв и где находятся риски для бизнеса."
            }
          },
          {
            "@type": "Question",
            "name": "Что можно оценивать у сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Набор компетенций формируется под конкретную должность и задачи бизнеса. Чаще всего оценивают профессиональные компетенции, коммуникацию, ответственность, инициативность, работу в команде, управленческие компетенции, лидерство, а для отдела продаж — навыки коммуникации с клиентами, выявления потребностей, презентации ценности, работы с возражениями и переговоров."
            }
          },
          {
            "@type": "Question",
            "name": "Какие методы оценки сотрудников используются?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Используются структурированные интервью, ассессмент-центр, оценка 360 градусов, тестирование, практические задания, анализ рабочих результатов и комплексная оценка, комбинирующая несколько методов. Метод подбирается под задачу оценки, а не наоборот."
            }
          },
          {
            "@type": "Question",
            "name": "Что такое оценка компетенций?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оценка компетенций — это определение того, какими знаниями, навыками и моделями поведения обладает сотрудник и как они соотносятся с требованиями его роли и задачами бизнеса. Она выявляет сильные стороны и зоны развития и становится основой для плана развития."
            }
          },
          {
            "@type": "Question",
            "name": "Чем оценка сотрудников отличается от оценки эффективности обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оценка сотрудников отвечает на вопрос, что сотрудник умеет сейчас и что ему нужно развивать. Оценка эффективности обучения отвечает на другой вопрос — изменилось ли что-то после уже проведённого обучения. Первая определяет потребность в развитии, вторая — результат обучения."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли оценивать сотрудников перед обучением?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, это один из самых полезных сценариев. Оценка перед обучением показывает текущий уровень сотрудников и дефициты, что позволяет нацелить программу на реальные потребности, а не проводить обучение для всех одинаково."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли по результатам оценки составить индивидуальный план развития?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. По результатам оценки для сотрудника формируется индивидуальный план развития, который фиксирует компетенцию, текущий и желаемый уровни, конкретные действия, сроки и критерии результата. Так оценка превращается в понятные шаги развития."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценка помогает формировать кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оценка выявляет сотрудников с высоким потенциалом, определяет их готовность к новой роли и выявляет дефицит управленческих компетенций. На этой основе строится индивидуальный план развития: обучение, наставничество, практика и повторная оценка."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли проводить оценку руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Для руководителей оцениваются управленческие компетенции: постановка задач, делегирование, контроль, обратная связь, развитие сотрудников и лидерство. Оценка руководителей связана с развитием управленческих компетенций и подготовкой кадрового резерва."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать модель оценки под конкретную компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Модель компетенций и критерии оценки формируются под конкретные должности, отрасль и задачи бизнеса. Универсального списка компетенций, который подходит всем компаниям одинаково, не существует."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько времени занимает оценка сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Продолжительность зависит от количества сотрудников, глубины оценки и выбранных методов. Оценка одной группы может занимать от нескольких дней до нескольких недель, включая подготовку инструментов, проведение оценочных мероприятий и анализ результатов. Точные сроки определяются после постановки задачи."
            }
          },
          {
            "@type": "Question",
            "name": "Что компания получает по результатам оценки?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Компания получает понятную картину компетенций сотрудников, выявленные зоны развития, понимание потенциала команды, кадровый резерв, индивидуальные планы развития и связь оценки с обучением. Это позволяет направлять бюджет на обучение туда, где он действительно нужен."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}